'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const ajax = require('../../helpers/ajax')

module.exports = class votingField extends Base {

	onInit() {
		this._widget.querySelector('.field-select').style.display = 'inherit'
		this._widget.querySelector('.field-value').style.display = 'none'
		this._widget.querySelector('.field-select').value = this._data.value || "Oblasť Dopravy"

		this._widget.querySelector('.field-select').onchange = () => {
			this._data.value = this._widget.querySelector('.field-select').value
		}
	}

	onDestroy() {
		this._widget.querySelector('.field-select').style.display = 'none'
		this._widget.querySelector('.field-value').style.display = 'inherit'
	}

	onSave() {
		this._widget.querySelector('.field-value').textContent = this._widget.querySelector('.field-select').value
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/voting-field/voting-field.edit.js
// module id = 507
// module chunks = 0